import { ScrewGroup } from '../../../../object-view/objects/screw';
import { APP_TEXTS } from '@texts';


const INPUTS = {
  default: {
    count: [
      {        
        label: APP_TEXTS.LABEL_BUTTONS_CUSTOM_N.Content,
        key: 'n'
      }
      
    ],
    
    padding: [
      {
        label: APP_TEXTS.LABEL_BUTTONS_CUSTOM_S.Content,
        key: 's1'       
      }
    ]
  },
  triangle: {
    count: [
      {
        label: APP_TEXTS.LABEL_BUTTONS_CUSTOM_N.Content,
        key: 'n'
      }
    ],
    padding: [
      {
        label: APP_TEXTS.LABEL_BUTTONS_CUSTOM_S.Content,
        key: 's'
      }
    ]
  },
  matrix: {
    count: [
      {
        label: APP_TEXTS.LABEL_BUTTONS_CUSTOM_Nx.Content,
        key: 'n'
      },
      {
        label: APP_TEXTS.LABEL_BUTTONS_CUSTOM_Ny.Content,
        key: 'm'
      }
    ],
    padding: [
      {
        label: APP_TEXTS.LABEL_BUTTONS_CUSTOM_Sx.Content,
        key: 's1'
      },
      {
        label: APP_TEXTS.LABEL_BUTTONS_CUSTOM_Sy.Content,
        key: 's2'
      }
    ]
  },
  circle: {
    count: [
      {
        label: APP_TEXTS.LABEL_BUTTONS_CUSTOM_Nx.Content,
        key: 'n'
      }
    ],
    padding: [
      {
        label: APP_TEXTS.LABEL_BUTTONS_CUSTOM_R.Content,
        key: 'diameter'
      }
    ]
  }
};

export default [
  {
    id: 'custom_linear',
    icon: 'icon_editor-custom-linear',
    inputLabels: INPUTS.default,
    config: {
      formation: ScrewGroup.formation.FILLED_SQUARE,
      count: {
        m: 1
      }
    },
    tooltip:"TT234"
  },
  {
    id: 'custom_triangular',
    icon: 'icon_editor-custom-triangular',
    inputLabels: INPUTS.triangle,
    config: {
      formation: ScrewGroup.formation.TRIANGLE,
      count: {
        m: 3
      }
    },
    tooltip:"TT213"
  },
  {
    id: 'custom_matrix',
    icon: 'icon_editor-custom-matrix',
    inputLabels: INPUTS.matrix,
    config: {
      formation: ScrewGroup.formation.FILLED_SQUARE
    },
    tooltip:"TT214"
  },
  {
    id: 'custom_edgeMatrix',
    icon: 'icon_editor-custom-edge-matrix',
    inputLabels: INPUTS.matrix,
    config: {
      formation: ScrewGroup.formation.EMPTY_SQUARE
    },
    tooltip:"TT214"
  },
  {
    id: 'custom_roundedEdgeMatrix',
    icon: 'icon_editor-custom-rounded-edge-matrix',
    inputLabels: INPUTS.matrix,
    config: {
      formation: ScrewGroup.formation.ROUNDED_EDGE_QUARE
    },
    tooltip:"TT215"
  },
  {
    id: 'custom_circle',
    icon: 'icon_editor-custom-circular',
    inputLabels: INPUTS.circle,
    config: {
      formation: ScrewGroup.formation.CIRCLE
    },
    tooltip:"TT216"
  }
];



// WEBPACK FOOTER //
// ./src/components/Editor/Anchors/Buttons/custom.js